/**
 * VAUPEL — Google-Ads-Conversion-Tracking (Shopify-Theme)
 * ------------------------------------------------------------------
 * Misst die drei Aktionen, die im Laden Geld bedeuten und die die
 * Google-&-YouTube-App NICHT mitbringt (die App misst nur Käufe):
 *
 *   1. Terminbuchung über cal.com (Modal-Embed)
 *   2. Klick auf eine Telefonnummer  (a[href^="tel:"])
 *   3. Klick auf "Route planen"      (Google-Maps-Link)
 *
 * Konto: VAUPEL-Website Ads (465-673-0060), Conversion-ID AW-663899401.
 * Aktionen + Ereignis-Snippets am 17.08.2026 live im Konto angelegt
 * (Ziele > Conversions > "Termin gebucht (cal.com)" / "Anruf-Klick
 * (tel-Link)" / "Route berechnen").
 *
 * EINBAU (Shopify Admin > Onlineshop > Theme > Code bearbeiten):
 *   1. Neue Datei anlegen: assets/vaupel-ads-conversions.js  → dieser Inhalt
 *   2. In layout/theme.liquid VOR </head> einfügen:
 *
 *        <script>
 *          window.VAUPEL_ADS = {
 *            id: 'AW-663899401',
 *            labels: {
 *              termin: 'AW-663899401/LV3eCM26oOMcEImaybwC',
 *              anruf:  'AW-663899401/8s8KCNC6oOMcEImaybwC',
 *              route:  'AW-663899401/glH7CNQ6oOMcEImaybwC'
 *            }
 *          };
 *        </script>
 *        <script src="{{ 'vaupel-ads-conversions.js' | asset_url }}" defer></script>
 *
 * WICHTIG: Das gtag-Basis-Tag ist bereits über die Google-&-YouTube-App
 * auf der Website eingebunden (inkl. Consent Mode v2, im Konto als
 * "Auf Website eingefügt" bestätigt). Dieses Skript setzt kein eigenes
 * Basis-Tag, sondern schiebt nur Events in die vorhandene dataLayer/
 * gtag-Instanz. Ohne Consent des Besuchers unterdrückt Consent Mode die
 * Übertragung automatisch — genau so ist es gewollt.
 */
(function () {
  'use strict';

  var cfg = window.VAUPEL_ADS || {};
  var L = cfg.labels || {};
  if (!cfg.id) return;

  /**
   * Termin-Wert nach Anlass. Grundlage (User-Angaben, Stand 18.08.2026):
   *
   *   Hochzeit: Bon 900-1200 EUR (Mittel 1050), Abschlussquote >80%
   *             -> 1050 x 0,80 = 840 EUR je ERSCHIENENEM Termin
   *   Anzug:    Bon 300-600 EUR (Mittel 450),  Abschlussquote >60%
   *             -> 450 x 0,60 = 270 EUR je ERSCHIENENEM Termin
   *
   * WICHTIG / OFFEN: Diese Werte gelten pro *erschienenem* Termin. Eine
   * Buchung ist nicht dasselbe wie ein wahrgenommener Termin. Eine echte
   * Show-Rate liegt noch NICHT vor, deshalb wird hier bewusst keine
   * erfunden. Sobald sie gemessen ist, lautet die korrekte Formel:
   *
   *   Buchungswert = Bon x Show-Rate x Abschlussquote
   *
   * Bis dahin sind 840/270 Obergrenzen. Fuer die Gebotssteuerung zaehlt
   * vor allem das VERHAELTNIS (Hochzeit ca. 3x Anzug), das von der
   * Show-Rate weitgehend unberuehrt bleibt, solange sie sich zwischen
   * beiden Terminarten nicht stark unterscheidet.
   *
   * cal.com liefert den gebuchten Termin-Typ im bookingSuccessful-Payload
   * (eventType.slug/title). Ohne Treffer greift bewusst der NIEDRIGERE
   * Wert, um unbekannte Buchungen nicht zu ueberbewerten.
   */
  function terminValue(booking) {
    var et = (booking && booking.eventType) || {};
    var text = ((et.slug || '') + ' ' + (et.title || '') + ' ' + (booking && booking.title || '')).toLowerCase();
    if (text.indexOf('hochzeit') > -1 || text.indexOf('bräutigam') > -1 || text.indexOf('braeutigam') > -1) return 840;
    if (text.indexOf('anzug') > -1 || text.indexOf('abiball') > -1 || text.indexOf('konfirmation') > -1
        || text.indexOf('jugendweihe') > -1) return 270;
    return 270;   // konservativer Fallback
  }

  // gtag-Shim: nutzt den dataLayer der Google-&-YouTube-App mit.
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }

  function conversion(label, value, id) {
    if (!label) return;
    var payload = { send_to: label };
    if (value) { payload.value = value; payload.currency = 'EUR'; }
    if (id) payload.transaction_id = id;   // verhindert Doppelzählung
    gtag('event', 'conversion', payload);
  }

  // ---------------------------------------------------------------- 1) Termin
  // cal.com-Embed feuert "bookingSuccessful", sobald die Buchung steht.
  // Der Loader in cal-booking.js hat window.Cal bereits angelegt; wir
  // warten notfalls, bis er da ist.
  var tries = 0;
  (function hookCal() {
    if (window.Cal) {
      try {
        window.Cal('on', {
          action: 'bookingSuccessful',
          callback: function (e) {
            var d = (e && e.detail && e.detail.data) || {};
            var uid = (d.booking && d.booking.uid) || (d.uid) || null;
            conversion(L.termin, terminValue(d.booking), uid);
          }
        });
      } catch (err) { /* Embed nicht erreichbar */ }
      return;
    }
    if (tries++ < 40) setTimeout(hookCal, 250); // max. 10 s
  })();

  // ------------------------------------------------- 2) Anruf & 3) Route
  var lastClick = 0;
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var now = Date.now();
    if (now - lastClick < 1500) return;      // Doppelklicks abfangen
    var href = a.getAttribute('href') || '';

    if (href.indexOf('tel:') === 0) {
      lastClick = now;
      // Telefonklick ist eine MICRO-Conversion: kann Bestandskunde,
      // Oeffnungszeiten-Frage oder Lieferstatus sein. Wert bewusst niedrig,
      // und in Google Ads muss die Aktion auf SEKUNDAER stehen
      // ("Nicht in Conversions einbeziehen"), damit Smart Bidding nicht
      // darauf optimiert wie auf einen echten Beratungstermin.
      conversion(L.anruf, 15);
      return;
    }
    if (/google\.[a-z.]+\/maps|maps\.app\.goo\.gl|openstreetmap\.org/.test(href)) {
      lastClick = now;
      conversion(L.route, 15);
    }
  }, true);

  // ---------------------------------------------- Kontaktformular (optional)
  // Shopify leitet nach dem Absenden auf ?contact_posted=true um.
  if (/[?&]contact_posted=true/.test(window.location.search) && L.formular) {
    conversion(L.formular, 25);
  }
})();
